import CustomizeCoverView from "../pages/CustomizeCoverView/CustomizeCoverView";
import DetailCustomizePlan from "../components/DetailCustomizePlan/DetailCustomizePlan";
import { Navigate } from "react-router-dom";
import ExplorePlansList from "../pages/ExplorePlans/ExplorePlansList";
import ExplorePlanView from "../pages/ExplorePlans/ExplorePlanView";
import ExploreProfileManageLayout from "../pages/ExplorePlans/ExploreProfileManageLayout";
import ExplorePlanItineraryManage from "../pages/ExplorePlans/ExplorePlanItineraryManage";
import ExplorePlanComparisonsManage from "../pages/ExplorePlans/ExplorePlanComparisonsManage";
import ExplorePlanNotesManage from "../pages/ExplorePlans/ExplorePlanNotesManage";

const CoverViewRoutes = [
  {
    path: "cover-api",
    children: [
      {
        path: "customize-covers-view",
        children: [
          { path: "", element: <CustomizeCoverView /> },
          { path: ":id", element: <DetailCustomizePlan /> },
        ],
      },
      {
        path: "explore-plans",
        children: [
          { path: "", element: <ExplorePlansList /> },
          { path: "view/:id", element: <ExplorePlanView /> },
          {
            path: "open/:id",
            element: <ExploreProfileManageLayout />,
            children: [
              { path: "", element: <Navigate to="itinerary" replace /> },
              { path: "itinerary", element: <ExplorePlanItineraryManage /> },
              { path: "comparisons", element: <ExplorePlanComparisonsManage /> },
              { path: "notes", element: <ExplorePlanNotesManage /> },
            ],
          },
        ],
      },
    ],
  },
];

export default CoverViewRoutes;